<template>
  <div id="testimonialTwo"></div>
</template>

<script>
export default {
  name: "TestimonialTwo",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        quote:
          "This product completely transformed how we work. The results speak for themselves.",
        name: "Sarah Johnson",
        role: "Head of Marketing",
        company: "TechCorp Inc.",
        rating: 5,
        chip: "Customer Story",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("testimonialTwo");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const quoteSize = exporting ? 48 : 48 * this.scale;
      const nameSize = exporting ? 30 : 30 * this.scale;
      const roleSize = exporting ? 22 : 22 * this.scale;
      const logoHeight = exporting ? 40 : 40 * this.scale;
      const chipSize = exporting ? 20 : 20 * this.scale;
      const starSize = exporting ? 26 : 26 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.light || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#10a37f";

      const rating = this.data.rating || 5;
      const starsHtml = Array(5)
        .fill(0)
        .map(
          (_, i) => `
        <span style="color: ${i < rating ? "#fbbf24" : "rgba(255,255,255,0.3)"}; font-size: ${starSize}px;">★</span>
      `,
        )
        .join("");

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 25%, #16213e 50%, #1a1a2e 75%, #0f0f0f 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Gradient orb effect -->
          <div style="
            position: absolute;
            top: -20%;
            right: -20%;
            width: 60%;
            height: 60%;
            background: radial-gradient(circle, ${primaryColor}25 0%, transparent 70%);
            pointer-events: none;
          "></div>
          <div style="
            position: absolute;
            bottom: -30%;
            left: -20%;
            width: 70%;
            height: 70%;
            background: radial-gradient(circle, #6366f130 0%, transparent 60%);
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" style="opacity: 0.9;" />
          </div>

          <!-- Testimonial content -->
          <div style="padding: 0 8%; position: relative; z-index: 1; flex: 1; display: flex; flex-direction: column; justify-content: center;">
            <div style="margin-bottom: 24px;">${starsHtml}</div>
            
            <div style="
              font-size: ${quoteSize}px;
              font-weight: 300;
              color: #ffffff;
              line-height: 1.4;
              margin-bottom: 40px;
            ">"${this.data.quote}"</div>

            <div style="display: flex; align-items: center; gap: 16px;">
              <div style="
                width: 4px;
                height: 48px;
                background: linear-gradient(180deg, ${primaryColor} 0%, #6366f1 100%);
                border-radius: 2px;
              "></div>
              <div>
                <p style="color: #ffffff; font-size: ${nameSize}px; margin: 0; font-weight: 600;">
                  ${this.data.name}
                </p>
                <p style="color: rgba(255, 255, 255, 0.6); font-size: ${roleSize}px; margin: 4px 0 0 0;">
                  ${this.data.role}${this.data.company ? ` at ${this.data.company}` : ""}
                </p>
              </div>
            </div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: rgba(255, 255, 255, 0.1);
                  backdrop-filter: blur(10px);
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 10px 24px;
                  letter-spacing: 0.05em;
                  text-transform: uppercase;
                  border: 1px solid rgba(255, 255, 255, 0.15);
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
